export class GreenhouseDataEvents {
  static locationsLoaded: string = "locationsLoaded";
  static locationSelected: string = "locationSelected";
  static greenhouseLoaded: string = "greenhouseLoaded";
  static greenhouseNotificationStatusUpdated: string = "greenhouseNotificationStatusUpdated";
    static notificationRecipientUpdated: string = "notificationRecipientUpdated";
}